import React from 'react';
import styled from 'styled-components';
import { Box } from './../components/layout/Grid';
import ThumbnailWithRatio from './../components/ThumbnailWithRatio';
import BaseSkeleton from './BaseSkeleton';

const Card = styled.div`
  border-radius: 5px;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
`;

const Content = styled.div`
  padding: 15px 30px;
`;

const VideoCardSkeleton = props => (
  <Card>
    <ThumbnailWithRatio path="">
      <Box as={BaseSkeleton} animation={props.animation} />
    </ThumbnailWithRatio>
    <Content>
      <BaseSkeleton
        height={10}
        width={100}
        marginBottom={20}
        animation={props.animation}
      />
      <BaseSkeleton
        height={10}
        width={100}
        marginBottom={20}
        animation={props.animation}
      />
      <BaseSkeleton
        height={10}
        width={60}
        marginBottom={20}
        animation={props.animation}
      />
    </Content>
  </Card>
);

export default VideoCardSkeleton;
